export const iconFontAwesomeCodingFontAwesome = (
	<i className="fa-solid fa-font-awesome"></i>
);
